<template lang="pug">
    .component
        .container
            .row
                .col-sm-12.col-lg-8
                    .spacer-l
                        h1 Aigents admin

                        form(@submit.prevent="validateBeforeSubmit" @keydown.enter.prevent="")
                            .form-group
                                label(for="email") Email address
                                input#email.form-control(
                                    type='text',
                                    name='email',
                                    placeholder='sample@gmail.com',
                                    v-model='user.email',
                                    v-validate="'required|email'",
                                )
                                p.text-danger(v-if="formSubmitted && errors.has('email')") {{ errors.first('email') }}
                            .form-group
                                label(for="password") Password
                                input#password.form-control(
                                    type='password',
                                    name='password',
                                    placeholder='password',
                                    v-model='user.password',
                                    v-validate="{rules: {required: true, min:6, regex: validation.PASSWORD_REGEXP }}"
                                )
                                p.text-warning(v-if="errors.has('password')") {{ errors.first('password') }}
                            .form-group(v-if='error')
                                .alert.alert-danger
                                    p {{ error }}
                            .form-group
                                .row
                                    .col-sm-8
                                        | Forgot your password?
                                        | &nbsp;
                                        router-link(to='Reset') Reset it here
                                        | .
                                    .col.text-right
                                        button.btn.btn-primary(type='submit') Login
</template>

<script>
import Auth from '@/auth'
import Messages from '@/constants/messages'
import Validation from '@/constants/validation'

export default {
  data() {
    return {
      formSubmitted: false,
      user: {
        email: '',
        password: ''
      },
      error: '',
      errorType: null,
      validation: Validation
    }
  },
  methods: {
    async validateBeforeSubmit(e) {
      this.formSubmitted = true
      await this.$validator.validateAll()
      if (!this.errors.any()) {
        this.submit()
      }
    },
    submit() {
      const user = {
          email: this.user.email.trim().toLowerCase(),
          password: this.user.password
        },
        redirectUrl = this.$route.query.redirect || '/'

      this.error = ''
      this.errorType = null

      Auth.login(this.$store, this.$router, user, redirectUrl).catch((err) => {
        if (!err.response) {
          this.error = Messages.BACKEND_UNAVAILABLE

          return false
        }

        this.errorType = err.response.status
        switch (err.response.status) {
          case 404:
            this.error = Messages.LOGIN_ERROR
            break
          case 424:
            if (err.errors === '{"errors":{"confirmation":"failed to send"}}') {
              this.error = Messages.EMAIL_ADDRESS_UNCONFIRMED_FAILED_RESEND
            } else {
              this.error = Messages.EMAIL_ADDRESS_UNCONFIRMED
            }
            break
          default:
            this.error = err.response.statusText
        }

        return false
      })
    }
  },
  beforeMount() {
    this.$validator.localize('en', {
      custom: {
        password: {
          regex: Messages.PASSWORD_COMPLEXITY
        }
      }
    })
  }
}
</script>
